import { FixtureResponseStat, FixtureResponseStatEntry } from "../models/api";
import { TeamFixtureBp } from "../models";

/**
 * Assigns provisional 3/2/1 bonus from a BPS list sorted highest first.
 * Tied players share the higher award and consume the lower places,
 * matching the official FPL tie rules.
 */
export const calculateProvisionalBonus = (sortedBps: FixtureResponseStatEntry[]): TeamFixtureBp[] => {
	if (sortedBps.length === 0) {
		return [];
	}

	let currentBpScore = sortedBps[0].value;
	let currentBp = 3;
	let nextBp = 3;
	const bpArr: TeamFixtureBp[] = [];

	for (let i = 0; i < sortedBps.length; i++) {
		const item = sortedBps[i];

		if (item.value < currentBpScore) {
			currentBpScore = item.value;
			currentBp = nextBp;
		}

		nextBp--;

		if (currentBp <= 0) {
			break;
		}

		bpArr.push({ ...item, score: currentBp });
	}

	return bpArr;
};

/**
 * Works out the bonus to show for a fixture. Returns an empty list when the
 * official bonus has already been assigned (the live feed then carries it), and
 * otherwise a provisional award from the BPS.
 */
export const provisionalBonusForFixture = (stats: FixtureResponseStat[]): TeamFixtureBp[] => {
	const assignedBonus = stats.find((x) => x.identifier === "bonus");
	const assignedBps = stats.find((x) => x.identifier === "bps");

	if (assignedBonus?.a?.length === 0 && assignedBonus?.h?.length === 0 && assignedBps != null) {
		const allBps = assignedBps.a.concat(assignedBps.h);
		allBps.sort((a, b) => b.value - a.value);
		return calculateProvisionalBonus(allBps);
	}

	return [];
};
